import request from '@/utils/request';

/**
 * 查询校区列表
 * @param query
 * @return {AxiosPromise}
 */
export function listCampus(query) {
  return request({
    url: '/system/user/selectSchool',
    method: 'get',
    params: query,
  });
}

/**
 * 新增校区
 * @param data
 * @return {AxiosPromise}
 */
export function addCampus(data) {
  return request({
    url: '/system/user/insertSchool',
    method: 'post',
    data: data,
  });
}

/**
 * 修改校区
 * @param data
 * @return {AxiosPromise}
 */
export function updateCampus(data) {
  return request({
    url: '/system/user/updateSchoolDept',
    method: 'put',
    data: data,
  });
}

/**
 * 查询省市区
 * @param id
 * @return {Promise<axios.AxiosResponse<any>> | *}
 */
export function getArea(id) {
  return request({
    url: '/system/region/subs/' + id,
    method: 'get',
  });
}

/**
 * 查询校区已购套餐列表
 * @param deptId
 * @return {AxiosPromise}
 */
export function listSchoolPackage(deptId) {
  return request({
    url: '/system/school/package/list',
    method: 'get',
    params: { deptId },
  });
}

/**
 * 查询可充值套餐列表（在售）
 * @return {AxiosPromise}
 */
export function listOnSalePackage() {
  return request({
    url: '/system/package/onSaleList',
    method: 'get',
  });
}

/**
 * 确认充值
 * @param data { deptId, sysPackageId, num, price: 0 }
 * @return {AxiosPromise}
 */
export function addRecharge(data) {
  return request({
    url: '/system/recharge/add',
    method: 'post',
    data: data,
  });
}
